module.exports = __webpack_public_path__ + "c28ee6f1fcec513ebbfccbef7504ca27.pdf";